import { gql } from 'src/generated/gql';

export const GET_SCHEDULING_PROVIDERS = gql(`
  query GetSchedulingProviders($patientId: ID!, $requestType: staff_DropInClinicRequestType!) {
    staff_getSchedulingProviders(patientId: $patientId, requestType: $requestType){
      id
      firstName
      lastName
    }
  }
`);
